export default "__VITE_ASSET__D9ubQf1V__"